export const intercomNewConversationUrl = (intercomUserId: string): string => {
  const appId = window.intercomSettings.app_id;
  return `https://app.intercom.com/a/inbox/${appId}/inbox/new-conversation?recipient=${intercomUserId}`;
};

export const openIntercomConversation = (intercomUserId: string): void => {
  window.open(intercomNewConversationUrl(intercomUserId), '_blank');
}
